import axios from "../axios-auth";
import orginal_axios from "axios";

export const layoutSettingService = {
    getLayoutSettingList,
    saveLayoutSetting,
    getLayoutSettingDetail,
    getLayoutSettingExcelExport,
    getAllLayoutSettingList,
};

function getLayoutSettingList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.layoutType) {
        params["layoutType"] = searchParams.layoutType;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.sessionName) {
        params["sessionName"] = searchParams.sessionName;
    }
    return axios.get("/auth/layout-settings", { params });
}

function saveLayoutSetting(layoutSetting) {
    if (!layoutSetting.id) {
        // new layoutSetting setting
        return axios.post("/auth/layout-setting", layoutSetting);
    } else {
        // edit
        return axios.put("/auth/layout-setting", layoutSetting);
    }
}

function getLayoutSettingDetail(id) {
    return axios.get("/auth/layout-setting/" + id);
}

function getLayoutSettingExcelExport(searchParams) {
    let params = {};

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.layoutType) {
        params["layoutType"] = searchParams.layoutType;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.sessionName) {
        params["sessionName"] = searchParams.sessionName;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/layout-setting-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAllLayoutSettingList(searchParams) {
    let params = {};

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.layoutType) {
        params["layoutType"] = searchParams.layoutType;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.sessionName) {
        params["sessionName"] = searchParams.sessionName;
    }

    return axios.get("/auth/print-all-layout-setting", { params });
}
